import { useState } from "react";
import { Dialog } from "@/components/Dialog";
import { Button, Field, Input } from "@/components/ui";

interface ConfirmDialogProps {
  title: string;
  description?: string;
  confirmLabel?: string;
  /** Require typing an exact string (e.g. the account e-mail) before confirming. */
  confirmInput?: { label: string; placeholder: string; match: string };
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
}

/** ConfirmDialog guards the few actions that can't be undone (remove member,
 * delete account). Everyday deletes use the Undo toast instead. */
export function ConfirmDialog({ title, description, confirmLabel = "Confirm", confirmInput, onConfirm, onClose }: ConfirmDialogProps) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const blocked = confirmInput ? text !== confirmInput.match : false;

  async function go() {
    setBusy(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()} title={title} description={description}>
      <div className="space-y-4">
        {confirmInput && (
          <Field label={confirmInput.label}>
            <Input value={text} onChange={(e) => setText(e.target.value)} placeholder={confirmInput.placeholder} autoFocus />
          </Field>
        )}
        <div className="flex justify-end gap-2">
          <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
          <Button variant="danger" size="sm" onClick={go} loading={busy} disabled={blocked}>{confirmLabel}</Button>
        </div>
      </div>
    </Dialog>
  );
}
